// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AddonDocMap } from './addon-doc-map';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AddonDoc extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String */
  description!: string;
  /** Binary */
  doc!: any;
  /** String(255) */
  fileName?: string;
  /** String(255) */
  mimeType?: string;
  /** String(60) */
  name?: string;
  /** Inv FK addonDocId */
  addonDocMaps!: AddonDocMap[];
}

